import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
} from '@angular/core'

@Directive({
  selector: '[clickOutside]',
  standalone: false,
})
export class ClickOutsideDirective {
  @Output() clickOutside = new EventEmitter<void>()

  constructor(private elementRef: ElementRef) {}

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement: HTMLElement): void {
    console.log('clicking')
    const isClickedInside =
      this.elementRef.nativeElement.contains(targetElement)
    if (!isClickedInside) {
      this.clickOutside.emit()
    }
  }
}
